import MinutesField from './MinutesField';

export default MinutesField;
